module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6116/img/provider-signup/community-creators-blobs.png"